import React, { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { Button, InputText, TextArea } from '@insurancemenu/imenu-components-lib/dist/components';
import { toJS } from 'mobx';
import SubtitleWithLines from 'components/common/general/SubtitleWithLines';
import { createStyles } from './styles';

interface QuoteFormProps {
  showFullTitle: boolean;
}

const QuoteForm = observer(({ showFullTitle }: QuoteFormProps): JSX.Element => {
  const classes = createStyles();
  // Mobx store
  const {
    quoteModalStore: { form, loading, saveQuoteModalChanges },
    domainStore: { domainHeader, closeChoiceModal },
    proposalCartStore: { cart },
  } = useRootStore();

  const convertedCart = toJS(cart);
  const convertedDomainHeader = toJS(domainHeader);
  const scrollRef = useRef<HTMLDivElement>(null);

  const onClose = (): void => {
    closeChoiceModal();
    scrollRef.current?.scrollTo(0, 0);
  };

  const onSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    void saveQuoteModalChanges(convertedCart.id, convertedCart.groupId, convertedDomainHeader.id, onClose);
  };

  return (
    <>
      {!loading && (
        <div ref={scrollRef}>
          <div className={classes.body}>
            {showFullTitle ? (
              <h3 className={classes.modalTitle}>Save cart & Email it</h3>
            ) : (
              <SubtitleWithLines text="Save cart & Email it" />
            )}
            <p className={classes.subtitle}>Email these plans to yourself or someone to review</p>
            <form className={classes.form} onSubmit={onSubmit} id="quote_form">
              <InputText
                label="Email"
                name="email"
                value={form.fields.email.value}
                onChange={form.onFieldChange}
                className={classes.fullInputLayout}
                validationPassed={!form.fields.email.unpassedValidationMsg}
                validationMessage={form.fields.email.unpassedValidationMsg || ''}
              />
              <InputText
                label="Name"
                name="name"
                value={form.fields.name.value}
                onChange={form.onFieldChange}
                className={classes.fullInputLayout}
                validationPassed={!form.fields.name.unpassedValidationMsg}
                validationMessage={form.fields.name.unpassedValidationMsg || ''}
              />
              <TextArea
                label="Message"
                name="message"
                value={form.fields.message.value}
                onChange={form.onFieldChange}
                className={classes.fullInputLayout}
                height="15rem"
                maxLength={10000}
              />
            </form>
          </div>
          <footer className={classes.footer}>
            <div className={classes.actionsBlock}>
              <Button type="outlined" onClick={closeChoiceModal} size="large">
                Cancel
              </Button>
              <Button
                color="primary"
                htmlType="submit"
                size="large"
                htmlForm="quote_form"
                disabled={!form.isFormValid()}
              >
                Submit
              </Button>
            </div>
          </footer>
        </div>
      )}
    </>
  );
});

export default QuoteForm;
